import MainLayout from './layout/MainLayout';
import TopMenu from './menu/TopMenu';
import SideMenu from './menu/SideMenu';
import Footer from './footer/Footer';
import MPMLoader from './loaders/MPMLoader';
import MPMError from './Errors'
import Regions from './commons/Regions';
import Tables from './commons/Tables';
import Statistics from './commons/Statistics';
import Message from './commons/Message'
import ChangeEntiteRattachement from './commons/ChangeEntiteRattachement';
import Unautorized from './layout/Unautorized';
import Confirmation from './modal/ConfirmationModal';
import SideMenuTwo from './menu/SideMenuTwo'
// Add All Components
const Components = {};
Components.MainLayout = MainLayout;
Components.TopMenu = TopMenu;
Components.SideMenu = SideMenu;
Components.SideMenuTwo = SideMenuTwo;
Components.Footer = Footer;
Components.MPMLoader = MPMLoader;
Components.MPMError = MPMError;

Components.Unautorized = Unautorized;
Components.Message = Message

Components.Regions = Regions;
Components.Tables = Tables;
Components.Statistics = Statistics;

Components.Modals = {
    Confirmation
}

// Componenets for page Dashboard;
Components.Dashboard = {
    ChangeEntiteRattachement: ChangeEntiteRattachement
};

export default Components;